import { uploadKocPhotoUrl } from '@/Axios/api/Media';
import { customAxios } from '@/Axios/index';
import { useAppDispatch, useAppSelector } from '@/Hooks/useAppRedux';
import { UpdatePostVodThumbnailRequest } from '@/Interfaces/I_modal';
import { updateVodThumbnail } from '@/Redux/slices/ModalSlice';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { message, Modal, Upload, UploadFile } from 'antd';
import { UploadChangeParam, UploadProps } from 'antd/lib/upload';
import React, { useState } from 'react';

const VodThumbnailModal = ({
  postUuid,
  visible,
  setVisible,
}: {
  postUuid: string;
  visible: boolean;
  setVisible: (value: boolean) => void;
}) => {
  const dispatch = useAppDispatch();
  const thumbnailId = useAppSelector((state) => state.modal.value.postDetail.vod?.thumbnailId);
  const thumbnailUrl = useAppSelector((state) => state.modal.value.postDetail.vod?.thumbnailUrl)
  const [isChanged, setIsChanged] = useState(false);

  const [fileList, setFileList] = useState<UploadFile[]>(
    [
      {
        name: 'original-thumbnail',
        uid: thumbnailId || "",
        url: thumbnailUrl || "",
      }
    ]
  );
  const [uploadFileLoading, setUploadFileLoading] = useState(false);

  const bearerToken = customAxios.defaults.headers.common.Authorization;
  const uploadPhotoUrl = customAxios.defaults.baseURL + uploadKocPhotoUrl;

  const handleChange: UploadProps['onChange'] = (param: UploadChangeParam<UploadFile>) => {
    if (!isChanged) {
      setIsChanged(true)
    }
    
    if (param.file.status === 'uploading') {
      setUploadFileLoading(true);
      setFileList([param.file]);
    } else if (param.file.status === 'done') {
      setUploadFileLoading(false);
      setFileList([param.file]);
    } else if (param.file.status === 'removed') {
      setUploadFileLoading(false);
      setFileList([]);
    } else if (param.file.status === 'error') {
      message.error("Cannot upload Photo, please try again")
      setIsChanged(false);
      setUploadFileLoading(false);
      setFileList(
        [
          {
            name: 'original-thumbnail',
            uid: thumbnailId || "",
            url: thumbnailUrl || "",
          }
        ]
      );
    }
  };

  const uploadButton = (
    <div>
      {uploadFileLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const onConfirm = () => {
    if (fileList.length === 1){
      const request = {
        uuid: postUuid,
        postVodThumbnailData: {
          thumbnailId: fileList[0]?.response[0].imageId,
          thumbnailUrl: fileList[0]?.response[0].imageUrl,
        }
      } as UpdatePostVodThumbnailRequest;
      dispatch(updateVodThumbnail(request));
    }
    setVisible(false);
  };

  const onCancel = () => {
    setUploadFileLoading(false);
    setFileList(
      [
        {
          name: 'original-thumbnail',
          uid: thumbnailId || "",
          url: thumbnailUrl || "",
        }
      ]
    );
    setVisible(false);
  };

  return (
    <Modal
      open={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      title="VOD Thumbnail"
      bodyStyle={{
        display: 'flex',
        justifyContent: 'center',
      }}
      okText="Save"
      okButtonProps={{ disabled: uploadFileLoading || (fileList.length !== 1) || !isChanged}}
      cancelButtonProps={{ disabled: uploadFileLoading }}
      closable={false}
      maskClosable={false}
    >
      <Upload
        listType="picture-card"
        onChange={handleChange}
        action={uploadPhotoUrl}
        headers={{
          authorization: bearerToken,
        }}
        name="images"
        className="info-image-upload"
        accept="image/*"
        fileList={fileList}
        disabled={uploadFileLoading}
        maxCount={1}
      >
        {uploadButton}
      </Upload>
    </Modal>
  );
};

export default VodThumbnailModal;
